export enum ContributionTypeEnum {
  GAME = 'game',
  GAME_CATEGORY = 'game_category',
  GAME_PROVIDER = 'game_provider',
  SPORT = 'sport',
  SPORT_TEAM = 'sport_team',
  SPORT_TOURNAMENT = 'sport_tournament',
}
